const GA4_ID = process.env.REACT_APP_GA4_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

const appendScript = (id, src) => {
  if (document.getElementById(id)) {
    return;
  }
  const script = document.createElement('script');
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

const initAnalytics = () => {
  if (GA4_ID) {
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
      window.gtag = (...args) => {
        window.dataLayer.push(args);
      };
    }
    window.gtag('js', new Date());
    window.gtag('config', GA4_ID, { send_page_view: false });
    appendScript('ga4-script', `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`);
  }
  if (CLARITY_ID) {
    if (!window.clarity) {
      window.clarity = (...args) => {
        window.clarity.q = window.clarity.q || [];
        window.clarity.q.push(args);
      };
    }
    appendScript('clarity-script', `https://www.clarity.ms/tag/${CLARITY_ID}`);
  }
};

const trackPageView = () => {
  if (GA4_ID && window.gtag) {
    const pagePath = `${window.location.pathname}${window.location.search || ''}`;
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_location: window.location.href
    });
  }
};

export const startAnalytics = () => {
  initAnalytics();
  trackPageView();
  window.addEventListener('popstate', trackPageView);
};
